import useSWR from "swr";
import { toTitleCase, useStoreState } from "../../../util/util";
import { useAuthContext } from "../../../components/Auth";

export const getAccountManagerCSM = (transaction: {
  account_manager_name: string;
  customer_service_rep_name: string;
}): string => {
  const { account_manager_name, customer_service_rep_name } = transaction;
  if (
    account_manager_name &&
    customer_service_rep_name &&
    account_manager_name !== customer_service_rep_name
  ) {
    return `${account_manager_name} / ${customer_service_rep_name}`;
  }
  if (account_manager_name) {
    return account_manager_name;
  }
  if (customer_service_rep_name) {
    return customer_service_rep_name;
  }
  return "--";
};

const UserFilters = ({
  id,
  firstname,
  lastname,
}: {
  id: string;
  firstname: string;
  lastname: string;
}) => ({
  text: toTitleCase(firstname + " " + lastname),
  value: id,
});

export const useAccountManagersCSMFilters = (
  scope: "quotes" | "samples" | "orders"
) => {
  const { storefront_id } = useStoreState();
  const { roleIsSomeKindOfSeller } = useAuthContext();
  const { data: accountManagersResponse } = useSWR<{
    data: { id: string; firstname: string; lastname: string }[];
  }>(
    roleIsSomeKindOfSeller
      ? `/v2/storefronts/${storefront_id}/users/account-managers?scope=${scope}`
      : null,
    {
      errorRetryCount: 0,
    }
  );

  const { data: customerServiceRepsResponse } = useSWR<{
    data: { id: string; firstname: string; lastname: string }[];
  }>(
    roleIsSomeKindOfSeller
      ? `/v2/storefronts/${storefront_id}/users/customer-service-reps?scope=${scope}`
      : null,
    {
      errorRetryCount: 0,
    }
  );

  return {
    accountManagers: accountManagersResponse?.data?.map(UserFilters) ?? [],
    customerServiceReps:
      customerServiceRepsResponse?.data?.map(UserFilters) ?? [],
  };
};
